<template>
  <div class="radio">
    <input
      class="radio__input"
      type="radio"
      :id="id"
      :name="name"
      :value="val"
      :disabled="disabled"
      @input="updateValue(val)"
      :checked="val === observableValue"
      @blur="$emit('blur')"
    />
    <label :for="id" class="radio__label">{{ label }}</label>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'bimRadio',
  props: {
    /**
     * Значение, которое должно вернуться в v-model при выборе радио-кнопки
     */
    val: {
      type: null,
      required: true
    },
    /**
     * Значение v-model
     */
    value: {
      type: null
    },
    /**
     * Подпись (label) радио-кнопки
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * id радио-кнопки. Прописывается для input и label одинаковый
     */
    id: {
      type: String,
      default: function () { return 'radio-id-' + this._uid }
    },
    /**
     * Имя радио-кнопки
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Отключение радио-кнопки
     */
    disabled: Boolean
  },
  data () {
    return {
      observableValue: this.value,
    }
  },
  methods: {
    updateValue (val) {
      this.$emit('input', val)

      this.observableValue = val
    }
  },
  watch: {
    value (value) {
      this.observableValue = value
    }
  }
}
</script>

<style lang="scss" scoped>
.radio {
  display: inline-flex;
  align-items: center;
}
.radio__input {
  display: none;
}

.radio__input + .radio__label::before {
  content: '';
  transition: 0.15s;
  width: 16px;
  height: 16px;
  border: solid 1px $white-color-700;
  margin-right: 8px;

  border-radius: 50%;
  background-color: transparent;
  box-sizing: border-box;
  position: relative;
  top: 0;
}

.radio__input + .radio__label {
  transition: 0.15s;
  display: flex;
  &:hover, &:active {
    &:before {
      border-color: $white-color-900;
    }
  }
}

.radio__input:checked + .radio__label::before {
  box-shadow: inset 0 0 0 2px white;
  background-color: $primary-color;
}

.radio__input:disabled + .radio__label::before {
  background-color: $white-color-100;
  border-color: $white-color-100;
  box-shadow: none;
}
</style>
